'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _withSpacing = require('../withSpacing');

var _withSpacing2 = _interopRequireDefault(_withSpacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styles = {
  'screen-small': '(max-width: 539px)',
  'screen-gt-small': '(min-width: 540px)',
  'screen-medium': '(max-width: 959px)',
  'screen-gt-medium': '(min-width: 960px)',
  'screen-large': '(max-width: 1247px)',
  'screen-gt-large': '(min-width: 1248px)',
  'screen-x-large': '(max-width: 1919px)',
  'screen-gt-x-large': '(min-width: 1920px)',
  'text': 'tcl__Text-03d692ab',
  'block': 'tcl__Text-b0b3d22f',
  'inline': 'tcl__Text-0f893f24',
  'bold': 'tcl__Text-5740cf80',
  'italic': 'tcl__Text-dcfec505',
  'small': 'tcl__Text-267ecb65',
  'truncated': 'tcl__Text-dec94145',
  'color-black': 'tcl__Text-be9c77e8',
  'color-white': 'tcl__Text-4f626d15',
  'color-grey': 'tcl__Text-458d0069',
  'color-light-grey': 'tcl__Text-2cd619e6',
  'color-teal': 'tcl__Text-e9e2980a',
  'color-green': 'tcl__Text-d8dde582',
  'color-orange': 'tcl__Text-c49192dd',
  'color-red': 'tcl__Text-57d44bd2'
};

/**
 * Default text. Use it for displaying inline text or full paragraphs.
 */

var Text = function Text(_ref) {
  var _classnames;

  var children = _ref.children,
      elName = _ref.elName,
      inline = _ref.inline,
      bold = _ref.bold,
      italic = _ref.italic,
      small = _ref.small,
      truncated = _ref.truncated,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ['children', 'elName', 'inline', 'bold', 'italic', 'small', 'truncated', 'color']);

  var className = (0, _classnames3.default)(styles.text, (_classnames = {}, _defineProperty(_classnames, styles.block, !inline), _defineProperty(_classnames, styles.inline, inline), _defineProperty(_classnames, styles.bold, bold), _defineProperty(_classnames, styles.italic, italic), _defineProperty(_classnames, styles.small, small), _defineProperty(_classnames, styles.truncated, truncated), _defineProperty(_classnames, styles['color-' + color], !!color && color), _classnames), props.className);

  var El = elName || (inline ? 'span' : 'p');

  if (!children) return null;
  return _react2.default.createElement(
    El,
    _extends({}, props, { className: className }),
    children
  );
};

Text.displayName = 'Text';
Text.propTypes = _extends({}, _withSpacing.propTypes, {

  /**
   * Any additional css classes.
   */
  className: _propTypes2.default.string,

  /**
   * Content.
   */
  children: _propTypes2.default.node,

  /**
   * Use custom element.
   */
  elName: _propTypes2.default.string,

  /**
   * Display as inline text.
   */
  inline: _propTypes2.default.bool,

  /**
   * Truncates text if it overflows.
   */
  truncated: _propTypes2.default.bool,

  /**
   * Display text in bold font-weight.
   */
  bold: _propTypes2.default.bool,

  /**
   * Display text in italic font-style.
   */
  italic: _propTypes2.default.bool,

  /**
   * Small text.
   */
  small: _propTypes2.default.bool,

  /**
   * Predefined icon color. By default it inherits from parent.
   */
  color: _propTypes2.default.oneOf(['black', 'grey', 'light-grey', 'white', 'teal', 'green', 'orange', 'red'])
});

Text.defaultProps = {
  className: '',
  inline: false,
  bold: false,
  italic: false,
  small: false,
  color: null,
  truncated: false,
  children: null,
  elName: null
};

exports.default = (0, _withSpacing2.default)(Text);